import * as React from "react";
import { memo } from "react";

const SvgPool = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20 20H0v-9.583h.833v8.75h18.333v-8.75H20V20Z" fill="#000" />
    <path
      d="m.593 13.71-.353-.754 2.895-1.358a2.42 2.42 0 0 1 2.063 0l2.084.978a1.6 1.6 0 0 0 1.298.025l2.516-1.062a2.431 2.431 0 0 1 1.975.039l2.088.979a1.59 1.59 0 0 0 1.35.001l.05-.019 2.67-.853.254.794-2.646.845a2.423 2.423 0 0 1-2.032-.014l-2.088-.979a1.598 1.598 0 0 0-1.297-.025L8.904 13.37a2.432 2.432 0 0 1-1.976-.039l-2.084-.977a1.592 1.592 0 0 0-1.355 0L.593 13.71Z"
      fill="#000"
    />
    <path
      d="M10.417 12.454h-.834V2.084C9.583.935 10.518 0 11.667 0h.833c1.149 0 2.083.935 2.083 2.084h-.833c0-.69-.56-1.25-1.25-1.25h-.833c-.69 0-1.25.56-1.25 1.25v10.37ZM15.833 12.917H15V2.083C15 .935 15.934 0 17.083 0h.834C19.064 0 20 .935 20 2.083h-.834c0-.689-.56-1.25-1.25-1.25h-.833c-.69 0-1.25.561-1.25 1.25v10.834Z"
      fill="#000"
    />
    <path
      d="M10 3.333h5.416v.834H10v-.834ZM10 6.25h5.416v.834H10V6.25ZM10 9.167h5.416V10H10v-.833Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgPool);
export default Memo;
